import { useEffect, useState } from "react";

const getInitialMatch = (query: string) =>
  typeof window !== "undefined" ? window.matchMedia(query).matches : false;

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => getInitialMatch(query));

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const media = window.matchMedia(query);
    const syncMatch = () => setMatches(media.matches);

    syncMatch();

    media.addEventListener("change", syncMatch);
    return () => media.removeEventListener("change", syncMatch);
  }, [query]);

  return matches;
}
